module.exports = __webpack_public_path__ + "media/images/lb/663-581d2429e6b621ac3dfc374e214cc943.svg";